/**
 * @author       esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  style.ts
 */

import { type Theme, css } from '@emotion/react'
import { BREAKPOINT_580, BREAKPOINT_MOBILE, Z_INDEX_GROUP_1 } from '@zcode-ui/themes'
import { gray60, ink } from '../../../../../styles/colors'

export const contact = css`
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media (max-width: ${BREAKPOINT_580}) {
    padding-top: 2px;
  }
`

export const msgBtnContainer = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const buttonContainer = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    width: 100%;
  }
`

export const phoneBtn = ({ typography }: Theme) => css`
  display: flex;
  flex: 2 2;
  height: 36px;
  margin-left: 10px;
  padding: 7px 12px;
  color: ${ink};
  font-weight: ${typography?.fontWeightBold ?? 'bold'};

  font-size: 14px;

  border: 0.5px solid ${gray60};
  border-radius: 5px;

  box-shadow: none;
  place-content: center;
`

export const isInfoOverlay = css`
  flex: unset;
  width: 315px;
`

export const msgBtn = ({ typography }: Theme) => css`
  z-index: ${Z_INDEX_GROUP_1};

  flex: 2 2;
  width: 100%;
  height: 36px;

  font-weight: ${typography?.fontWeightRegular ?? 600};

  font-size: 14px;

  border-radius: 5px;
  box-shadow: none;

  &:hover {
    border-radius: 5px;
    box-shadow: none;
  }

  &:first-of-type {
    margin-right: 0;
  }

  &:last-child {
    margin-right: 0;
    margin-left: 10px;
  }

  &:only-child {
    margin: 0;
  }
`

export const messageBtn = css`
  height: 40px;
`

export const hasPhone = css`
  margin-right: 10px;
`

export const ctaContainer = css`
  display: flex;
  width: 100%;
`
